/*global $ */
export default function($) {

  const searchHeader = $('.js-search-header');
  const searchTrigger = $('.js-search-button');

  "use strict";

  //Checks if li has sub (ul) and adds class for toggle icon - just an UI
  $('.menu > ul > li:has( > ul)').addClass('menu-dropdown-icon');

  //Adds menu-mobile class (for mobile toggle menu) before the normal menu
  //Mobile menu is hidden if width is more then 959px, but normal menu is displayed
  //Normal menu is hidden if width is below 959px, and jquery adds mobile menu
  //Done this way so it can be used with wordpress without any trouble
  $(".menu > ul > li").hover(function (e) {
      if ($(window).width() > 943) {
          $(this).children("ul").stop(true, false).toggle();
          e.preventDefault();
      }
  });
  //If width is more than 943px dropdowns are displayed on hover

  $(".menu > ul > li").click(function () {
      if ($(window).width() <= 943) {
          $(this).children("ul").toggle();
      }
  });
  //If width is less or equal to 943px dropdowns are displayed on click (thanks Aman Jain from stackoverflow)

  // Prevent click on first level links with children
  $(".menu > ul > li:has( > ul) > a").click(function (e) {
      e.preventDefault();
  })

  $(".menu-mobile").click(function (e) {
      $(".menu > ul").toggleClass('show-on-mobile');
      e.preventDefault();
      // Close searchbar
      if( searchTrigger.hasClass('open') ) {
        searchTrigger.removeClass('open');
        searchTrigger.find('a').html('Rechercher');
        searchHeader.css('top', '-13rem');
        searchHeader.removeClass('open');
      }
  });
  //when clicked on mobile-menu, normal menu is shown as a list, classic rwd menu story (thanks mwl from stackoverflow)

}
